import React from 'react';
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2'
import { OverlayTrigger } from 'react-bootstrap';
import { logout } from "../services/auth";

const Exit = (props) => {

    const toggleLogout = () => {
        Swal.fire({
            title: 'Tem a certeza?',
            text: 'Deseja mesmo sair do sistema?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim',
            cancelButtonText: 'Cancelar',
        }).then((result) => {
            if (result.value) {
                logout()
                window.location.reload();
            }
        })
    }

    return (
        <>
            {props.menu === true ?
                <OverlayTrigger
                    placement="right"
                    delay={{ show: 250, hide: 400 }}
                    overlay={props.renderSair}
                >
                    <Link to="#" onClick={toggleLogout} data-toggle="tooltip" data-placement="right">
                        <i className="fas fa-power-off"></i>
                        <p>Sair</p>
                    </Link>
                </OverlayTrigger>
                :
                <Link to="#" onClick={toggleLogout} className="sair-sistema">Sair <i className="fas fa-power-off" style={{color: 'red'}}></i></Link>
            }
        </>
    )
};

export default Exit;